<script setup>
import { Container } from '@codinglabsau/ui'
import Table from '@/Components/Tables/Convicts.vue'
import IndexHeader from '@/Components/Convicts/IndexHeader.vue'
import HeadMetaTags from '@/Components/HeadMetaTags.vue'

defineProps({
  firstname: String,
  surname: String,
  convicts: Object,
})
</script>

<template>
  <HeadMetaTags
    title="Convicts By Name"
    description="A Index of all of our recorded convicts by First name and Surname."
    :canonical="route('convicts.index.firstname', [firstname, surname])"
    :url="route('convicts.index.firstname', [firstname, surname])"
  />
  <Container>
    <IndexHeader />
    <div class="rounded-b-lg bg-white p-3 pt-4">
      <Table v-if="convicts.data.length > 0" :convicts="convicts" disable-search />
      <div
        v-else
        class="flex h-56 w-full items-center justify-center rounded-b bg-gray-200 text-xl text-gray-500"
      >
        No results found
      </div>
    </div>
  </Container>
</template>
